/**
 * Badge utility functions for consistent color shading across the application
 * Used for ContactType, MembershipType, and CompanyType badges
 */

/**
 * Map contactTypeId to an aqua shade (0-9)
 * @param {number} contactTypeId - The contact type ID
 * @returns {string} CSS class name for aqua badge shading
 */
export const getAquaBadgeClass = (contactTypeId) => {
    const shade = (parseInt(contactTypeId, 10) || 0) % 10
    return `custom-badge-aqua-${shade}`
}

/**
 * Map membershipTypeId to an orange shade (0-9)
 * @param {number} membershipTypeId - The membership type ID
 * @returns {string} CSS class name for orange badge shading
 */
export const getOrangeBadgeClass = (membershipTypeId) => {
    const shade = (parseInt(membershipTypeId, 10) || 0) % 10
    return `custom-badge-orange-${shade}`
}

/**
 * Map companyTypeId to a green shade (0-9)
 * @param {number} companyTypeId - The company type ID
 * @returns {string} CSS class name for green badge shading
 */
export const getGreenBadgeClass = (companyTypeId) => {
    const shade = (parseInt(companyTypeId, 10) || 0) % 10
    return `custom-badge-green-${shade}`
}
